import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { UserRelationType } from './types';
import { createCallbackActionCreator } from '../../Stream/helpers';

export const initializeUserStream = createAction(
  `${actionKey}.INIT`,
  (streamId: string, deviationId: number, type: UserRelationType) => ({
    deviationId,
    type,
    streamId,
  })
);

export const fetchNextUsers = createCallbackActionCreator(
  `${actionKey}.FETCH_NEXT`
);
